import { createSelector } from '@ngrx/store';
import { Installer } from '../../domains/users';
import { ReputationScore, ReputationTier, getTierFromScore } from '../../domains/users/reputation-score/reputation-score.model';
import { allReputationScores } from '../../domains/users/reputation-score/reputation-score.state';
import { currentInstaller } from './store/profile.selectors';

export const currentInstallerReputationScoreEntity = createSelector(
  allReputationScores,
  currentInstaller,
  (reputationScores: ReputationScore[], installer?: Installer): ReputationScore | undefined =>
    installer ? reputationScores.find(score => score.userId === installer.id) : undefined,
);

export interface ReputationScoreWithTier extends ReputationScore {
  tier: ReputationTier;
  tierId: number;
}

export const currentInstallerReputationScore = createSelector(
  currentInstallerReputationScoreEntity,
  (reputationScore?: ReputationScore): ReputationScoreWithTier | undefined => {
    if (!reputationScore || !reputationScore.reputationScore) {
      return undefined;
    }

    const tier = getTierFromScore(reputationScore.reputationScore);
    const tierId = tier === ReputationTier.Rookie ? 0
      : tier === ReputationTier.Intermediate ? 1
        : tier === ReputationTier.Experienced ? 2
          : tier === ReputationTier.Proficient ? 3
            : tier === ReputationTier.Expert ? 4
              : tier === ReputationTier.Master ? 5
                : tier === ReputationTier.Artisan ? 6
                  : 7;

    return {
      ...reputationScore,
      tier,
      tierId,
    };
  },
);
